import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Loader2 } from "lucide-react";
import { isValidPhone } from "../../lib/live";

export const StartForm = ({ onStart }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return setError("Digite seu nome.");
    if (!isValidPhone(phone)) return setError("Digite seu WhatsApp com DDD, por exemplo: 11 91234-5678");
    setError("");
    setBusy(true);
    try {
      await onStart(name.trim().slice(0, 60), phone);
    } catch (err) {
      setError(err?.message || "Não foi possível iniciar. Tente novamente.");
      setBusy(false);
    }
  };

  return (
    <motion.form onSubmit={submit} className="sp-card p-5" data-testid="support-start-form"
      initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}>
      <p className="sp-eyebrow">Comece por aqui</p>
      <label className="sp-label mt-3">Seu nome</label>
      <input data-testid="support-start-name" className="sp-input" value={name} autoComplete="name"
        onChange={(e) => setName(e.target.value)} placeholder="Como podemos te chamar?" maxLength={60} />
      <label className="sp-label mt-3">WhatsApp com DDD</label>
      <input data-testid="support-start-phone" className="sp-input" value={phone} type="tel" inputMode="tel" autoComplete="tel"
        onChange={(e) => setPhone(e.target.value)} placeholder="(11) 91234-5678" maxLength={20} />
      {error && <p data-testid="support-start-error" className="text-[13px] text-[#FF8A8A] mt-3">{error}</p>}
      <motion.button data-testid="support-start-submit" disabled={busy} className="sp-cta mt-5" whileTap={{ scale: 0.97 }}>
        {busy ? <Loader2 size={18} className="animate-spin" /> : <>Falar com o suporte <ArrowRight size={18} /></>}
      </motion.button>
    </motion.form>
  );
};
